import HeaderNavigation from "@/components/application/header-navigation";
import NewStoreForm, {
  NewStoreFormData,
} from "@/components/application/new-store-form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Spinner } from "@/components/ui/spinner";
import useTranslations from "@/hooks/use-translations";
import { useForm } from "@inertiajs/react";

function NewStore() {
  const { t } = useTranslations("admin.stores.new");

  const form = useForm<NewStoreFormData>({
    store: {
      name: "",
      subdomain: "",
    },
  });

  return (
    <div className="bg-secondary min-h-screen flex flex-col">
      <HeaderNavigation />
      <section className="flex flex-1 flex-col items-center justify-center">
        <Card className="w-full max-w-sm">
          <CardHeader>
            <CardTitle>{t("title")}</CardTitle>
          </CardHeader>
          <CardContent>
            <NewStoreForm form={form} />
          </CardContent>
          <CardFooter>
            <Button
              type="submit"
              className="w-full"
              form="new-store-form"
              disabled={form.processing}
            >
              {form.processing && <Spinner />}
              {t("submit")}
            </Button>
          </CardFooter>
        </Card>
      </section>
    </div>
  );
}

export default NewStore;
